import { render } from "./DietModal.vue?vue&type=template&id=2f364cc3&scoped=true"
import script from "./DietModal.vue?vue&type=script&lang=js"
export * from "./DietModal.vue?vue&type=script&lang=js"

import "./DietModal.vue?vue&type=style&index=0&id=2f364cc3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f364cc3"]])

export default __exports__